import { HttpClient } from '@angular/common/http';
import {
  APP_INITIALIZER,
  EnvironmentProviders,
  importProvidersFrom,
  Provider,
} from '@angular/core';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { I18nService } from './i18n.service';
import { MultiTranslateHttpLoader } from './multi-translate-loader';

// Função que será executada na inicialização da aplicação
function initializeApp(
  translate: TranslateService,
  i18nService: I18nService
): () => Promise<any> {
  return () =>
    new Promise<void>((resolve) => {
      // Prioridade: escolha manual do seletor → idioma do navegador → pt
      const langToUse = i18nService.getStoredLanguage();

      // Define o idioma no nosso serviço e no ngx-translate
      i18nService.setLanguage(langToUse);
      translate.setDefaultLang(langToUse);

      // Espera o carregamento dos arquivos de tradução antes de resolver
      forkJoin([
        translate.use(langToUse),
        // Adicione mais observables aqui se precisar esperar por mais dados
      ]).subscribe(() => {
        resolve();
      });
    });
}

export function provideI18n(scope: string): (Provider | EnvironmentProviders)[] {
  return [
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new MultiTranslateHttpLoader(http, scope),
          deps: [HttpClient],
        },
        fallbackLang: 'pt', // Mantemos um padrão, mas o initializer vai sobrepor
      })
    ),
    TranslateService,
    // Adiciona o APP_INITIALIZER
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [TranslateService, I18nService],
      multi: true,
    },
  ];
}
